import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import React, { useState } from "react";
import { localeDateEndDate, localeDateStartDate } from "../constants/DateUtil/DateUtil";

const RiderPickupDeliveryOrderBookingModal = ({
  riderPickupDeliveryOrderBookingModalVisible,
  setRiderPickupDeliveryOrderBookingModalVisible,
  sendDataToOrdersPageFromFilter,
  upDateSelectedStatus,
  OrderStatus,
  status,
  text,
}) => {
  let initialStartDate = new Date();

  const [startDate, setStartDate] = useState(() => {
    const d = new Date(initialStartDate);
    d.setDate(d.getDate() - 30);
    return d;
  });

  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));
  const [errorMessage, setErrorMessage] = useState("");

  const minimumDate = new Date();
  minimumDate.setMonth(minimumDate.getMonth() - 1000);

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3);

  const maximumValidDate = maximumDate;

  const handleStartDateChange = (selectedDate) => {
    if (selectedDate !== undefined) {

      const currentTime = new Date();
      selectedDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());

      setStartDate(selectedDate);
    }
  };

  const handleEndDateChange = (selectedDate) => {
    if (selectedDate !== undefined) {
      const currentTime = new Date();
      selectedDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());

      setEndDate(selectedDate);
    }
  };

  const handleConfirmPickup = () => {
    // Create a new pickup request object
    // {"endDate": 2024-12-28T10:03:43.023Z, "startDate": 2024-12-26T10:03:00.000Z}
    const newSchedular = {
      startDate: localeDateStartDate(new Date(startDate)), // Ensure toISOString() is called here
      endDate: localeDateEndDate(new Date(endDate)), // Ensure toISOString() is called here
      selectedStatus: "ORDER_BOOKED"
    };

    // Reset the form fields
    setStartDate(new Date(initialStartDate));
    setEndDate(new Date(initialEndDate));
    setErrorMessage("");

    // Close the modal
    setRiderPickupDeliveryOrderBookingModalVisible(false);
    sendDataToOrdersPageFromFilter({
      newSchedular,
    });
  };

  const handleModalClose = () => {
    setRiderPickupDeliveryOrderBookingModalVisible(!riderPickupDeliveryOrderBookingModalVisible);
    setStartDate(new Date(initialStartDate));
    setEndDate(new Date(initialEndDate));
    setErrorMessage("");
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={riderPickupDeliveryOrderBookingModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!riderPickupDeliveryOrderBookingModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <img
                style={{
                  height: 45,
                  width: 45,
                  // alignSelf: 'center',
                }}
                src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              />

              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Select Date
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div className="flex-auto mt-1 mx-4">
              <p className="font-bold block mb-2 ml-2">Start Date</p>
              <Calendar
                id="buttondisplay"
                value={startDate}
                onChange={(e) => handleStartDateChange(e.value)}
                showIcon
                minDate={minimumDate}
                maxDate={maximumValidDate}
                className="w-full  bg-white-alpha-20 border-round-lg p-1 text-lg text-primary-50"
                dateFormat="dd/mm/yy"
              />
            </div>

            <div className="flex-auto mt-1 mx-4">
              <p className="font-bold block mb-2 ml-2">End Date</p>
              <Calendar
                id="buttondisplay"
                value={endDate}
                onChange={(e) => handleEndDateChange(e.value)}
                showIcon
                minDate={minimumDate}
                maxDate={new Date()}
                className="w-full  bg-white-alpha-20 border-round-lg p-1 text-lg text-primary-50"
                dateFormat="dd/mm/yy"
              />
            </div>

            <Button
              onClick={handleConfirmPickup}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Submit
              </p>
            </Button>

            {errorMessage && (
              <div className="flex-auto">
                <p className="font-normal text-xl block mb-2">{errorMessage}</p>
              </div>
            )}
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default RiderPickupDeliveryOrderBookingModal;
